import { signal } from "@preact/signals-react";

import type { HAPDocument } from "@/shared/api/api-client";

export const hapState = signal<HAPDocument>({ years: {} });
